import { useEffect, useState } from "react";
import { getRedirectResult } from "firebase/auth";
import { auth } from "../firebase";

const API_URL = process.env.NODE_ENV === 'development' ? '' : (process.env.REACT_APP_API_URL || 'https://ceindiazone2.in');

const AuthHandler = () => {
  const [macAddress] = useState(null); 

  useEffect(() => {
    // 0. Handle Firebase Google Redirect Result (for Mobile Chrome/Safari redirect login)
    if (auth) {
      getRedirectResult(auth)
        .then(async (result) => {
          if (result && result.user) {
            const user = result.user;
            const payload = {
              email: user.email,
              name: user.displayName || "Google User",
              googleId: user.uid,
              deviceModel: navigator.userAgent ? navigator.userAgent.substring(0, 250) : "Unknown",
              platform: "Web",
              macAddress: macAddress
            };

            const response = await fetch(`${API_URL}/api/auth/google-login`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(payload)
            });

            if (!response.ok) {
              const errData = await response.json().catch(() => ({}));
              throw new Error(errData.message || `Backend returned status ${response.status}`);
            }

            const data = await response.json();
            if (data && (data.id || data.currentSessionToken)) {
              localStorage.setItem("user", JSON.stringify(data));
              if (data.role === 'ADMIN') {
                localStorage.setItem("adminUser", JSON.stringify(data));
                alert(`Welcome Admin ${data.name}`);
                window.location.href = "/admin/dashboard";
              } else {
                alert(`Welcome ${data.name}`);
                const redirectUrl = sessionStorage.getItem('loginRedirect') || '/';
                sessionStorage.removeItem('loginRedirect');
                window.location.href = redirectUrl;
              }
            } else {
              throw new Error("Invalid user response from backend");
            }
          }
        })
        .catch((err) => {
          console.error("Firebase redirect result error:", err);
          alert("Google sign-in failed: " + err.message);
        });
    }

    // 1. Intercept KingsChat OAuth `code` from query parameters
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get("code");
    if (code) {
      // Clear the query parameter from URL to prevent infinite loops if user refreshes
      window.history.replaceState({}, document.title, window.location.pathname);
      // Redirect to the backend callback to exchange code for token
      window.location.href = `${API_URL}/api/auth/kingschat/callback?code=${code}`;
      return;
    }

    // 2. Process Google OAuth `access_token` from URL hash
    const hash = window.location.hash;
    if (hash && hash.includes("access_token")) {
      const params = new URLSearchParams(hash.substring(1));
      const token = params.get("access_token");

      if (token) {
        window.history.pushState(null, null, " ");

        const processGoogle = (accessToken) => {
          fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
            headers: { Authorization: `Bearer ${accessToken}` }
          })
            .then(res => {
              if (!res.ok) throw new Error(`Google returned status ${res.status}`);
              return res.json();
            })
            .then(async (googleUser) => {
              if (googleUser && googleUser.sub) {
                const payload = {
                  email: googleUser.email,
                  name: googleUser.name || "Google User",
                  googleId: googleUser.sub,
                  deviceModel: navigator.userAgent ? navigator.userAgent.substring(0, 250) : "Unknown",
                  platform: "Web",
                  macAddress: macAddress
                };
                
                const response = await fetch(`${API_URL}/api/auth/google-login`, {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify(payload)
                });
                
                if (!response.ok) {
                  const errData = await response.json().catch(() => ({}));
                  throw new Error(errData.message || `Backend returned status ${response.status}`);
                }
                
                const data = await response.json();
                if (data && (data.id || data.currentSessionToken)) {
                  localStorage.setItem("user", JSON.stringify(data));
                  if (data.role === 'ADMIN') {
                    localStorage.setItem("adminUser", JSON.stringify(data));
                    alert(`Welcome Admin ${data.name}`);
                    window.location.href = "/admin/dashboard";
                  } else {
                    alert(`Welcome ${data.name}`);
                    window.location.href = "/";
                  }
                } else {
                  throw new Error("Invalid user response from backend");
                }
              } else {
                throw new Error("Could not extract user details from Google response");
              }
            })
            .catch(err => {
               console.error("Google login error:", err);
               alert("Google login failed: " + err.message);
            });
        };

        // All access_tokens in URL hash are now exclusively Google (KingsChat uses Server code flow)
        processGoogle(token);
        sessionStorage.removeItem("login_provider");
      }
    }
  }, [macAddress]);

  return null;
};

export default AuthHandler;
